import Dashboard from "../components/Dashboard";
import Contacto from "../components/Contacto";

const ContactoPage = () => {
  return (
    <Dashboard>
      <Contacto />
    </Dashboard>
  );
};

export default ContactoPage;
